import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="faq"
export default class extends Controller {
  static targets = ["chevron", "displayZone", "editZone"];

  declare chevronTarget: HTMLElement;
  declare displayZoneTarget: HTMLElement;
  declare editZoneTarget: HTMLElement;

  open() {
    this.displayZoneTarget.classList.add("hidden");
    this.editZoneTarget.classList.remove("hidden");
  }

  close() {
    this.displayZoneTarget.classList.remove("hidden");
    this.editZoneTarget.classList.add("hidden");
  }

  toggle() {
    if (this.editZoneTarget.classList.contains("hidden")) {
      this.open();
      this.chevronTarget.classList.add("rotate-180");
    } else {
      this.close();
      this.chevronTarget.classList.remove("rotate-180");
    }
  }
}
